import { render, staticRenderFns } from "./VerificationDetails.vue?vue&type=template&id=609dc702"
import script from "./VerificationDetails.vue?vue&type=script&lang=js"
export * from "./VerificationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports